import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      "&.MuiGrid-spacing-xs-2": {
        width: "calc(100% + 14px)",
        margin: -7,
        "& > .MuiGrid-item": {
          padding: 7
        }
      }
    }
  },
  infoPaper: {
    minHeight: 86,
    maxHeight: 86,
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "14px 16px",
    position: "relative",
    overflow: "hidden",
    flexWrap: "nowrap",
    flex: "auto",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  pointerAvailable: {
    cursor: "pointer"
  },
  corner: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
    width: 18,
    height: 18,
    "&:after": {
      zIndex: 0,
      content: "''",
      position: "absolute",
      top: 0,
      right: 0,
      borderColor: "transparent",
      borderStyle: "solid",
      borderWidth: 18,
      borderRightColor: "#f6f6f6",
      borderTopColor: "#f6f6f6"
    }
  },
  cornerIcon: {
    zIndex: 1,
    fontSize: 13,
    color: "#7d7d7d"
  },
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 42,
    minHeight: 42,
    width: 42,
    height: 42,
    color: "#51c69e",
    backgroundColor: "rgba(97, 198, 158, 0.15)",
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "50%",
    marginRight: 16,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      zIndex: 0,
      width: 145,
      height: 145,
      left: -30,
      top: -26,
      marginRight: 0,
      opacity: "0.08",
      border: `1px solid ${theme.palette.secondary.dark}`,
      backgroundColor: "rgba(97, 198, 158, 0.15)",
      boxSizing: "border-box",
      textAlign: "center",
      lineHeight: "normal"
    }
  },
  bgBadge: {
    position: "absolute",
    zIndex: 0,
    top: -33,
    opacity: 0.05,
    [theme.breakpoints.down("xs")]: {
      top: -28
    }
  },
  roundedSegments: {
    height: "auto",
    fontSize: 190
  },
  badgeIcon: {
    width: 26,
    [theme.breakpoints.down("xs")]: {
      fontSize: 80,
      width: 80
    }
  },
  blockContent: {},
  count: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 22,
    lineHeight: "normal",
    [theme.breakpoints.down("xs")]: {
      height: 38,
      zIndex: 10,
      fontSize: 36,
      flexBasis: "auto",
      marginBlockStart: 0,
      marginBlockEnd: 0
    }
  },
  label: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 12,
    lineHeight: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
      zIndex: 10
    }
  }
}));
